export { CustomerPlanSeatsComponent } from './customer-plan-seats.component';
